import * as _ from "lodash";
import * as React from "react";
import { OverlayTrigger, Popover, Row } from "react-bootstrap";
import * as semver from "semver";
import { setLastReadVersion } from "../actions/AppActions";
import { AppContext, releaseNoteStorageKey } from "../App";
import NotificationMessageNotifier from "./NotificationMessageNotifier";
const NotificationCenter = () => {
    const target = React.useRef(null);
    const { appState, dispatch } = React.useContext(AppContext);
    const [isShowingPopover, setIsShowingPopover] = React.useState(false);
    const releaseNote = {
        version: "5.3.4",
        intercomLink: "https://docs.frends.com/en/articles/3686971-5-3-release-notes#534"
    };
    const [isTriggeringAnimation, setIsTriggeringAnimation] = React.useState(false);
    const shouldTriggerAnimation = () => {
        var _a, _b, _c, _d;
        if (!_.isEmpty((_a = appState) === null || _a === void 0 ? void 0 : _a.notificationMessages) && ((_b = appState) === null || _b === void 0 ? void 0 : _b.notificationMessages.some((s) => s.viewed !== true)) ||
            ((_c = appState) === null || _c === void 0 ? void 0 : _c.lastReadVersion) !== "" && !_.isEqual((_d = appState) === null || _d === void 0 ? void 0 : _d.lastReadVersion, releaseNote.version)) {
            return true;
        }
        else {
            return false;
        }
    };
    React.useEffect(() => {
        setIsTriggeringAnimation(shouldTriggerAnimation());
    }, [appState]);
    React.useEffect(() => {
        if (isShowingPopover) {
            setLastReadVersion(dispatch, releaseNote.version, releaseNoteStorageKey);
            setIsTriggeringAnimation(shouldTriggerAnimation());
        }
    }, [isShowingPopover]);
    const toggleIsShowingPopover = () => {
        setIsShowingPopover(!isShowingPopover);
    };
    const popOver = (React.createElement(Popover, { id: "navigation-notification-popover", style: { padding: 0 } },
        React.createElement(NotificationMessageNotifier, { state: { appState, dispatch } }),
        React.createElement("div", { style: { overflowY: "auto" } },
            React.createElement(Row, null,
                React.createElement("h4", { style: { marginTop: 0 } },
                    React.createElement("strong", null, "Release notes")),
                React.createElement("a", { href: releaseNote.intercomLink, target: "_blank", className: "italic-blue-link" },
                    React.createElement("p", null,
                        "Release notes for ",
                        semver.valid(semver.coerce(releaseNote.version)))),
                React.createElement("a", { target: "_blank", className: "italic-blue-link", href: "https://docs.frends.com/en/collections/1192384-release-notes" }, "All release notes")))));
    return (React.createElement("li", { role: "presentation", id: "navigation-notification", ref: target, onClick: toggleIsShowingPopover },
        React.createElement(OverlayTrigger, { trigger: "click", placement: "bottom", overlay: popOver, containerPadding: 20, rootClose: true },
            React.createElement("p", { className: "navbar-text" },
                React.createElement("i", { className: "fa fa-bell pointer", id: `navigation-changelog-bell${isTriggeringAnimation ? "-animating" : ""}` }))),
        isTriggeringAnimation && React.createElement("div", { id: "navigation-changelog-badge" })));
};
export default NotificationCenter;
